 angular
   .module('vppApp')
   .service('SamlLogin', SamlLogin);
  SamlLogin.$inject = ['$location', '$rootScope', 'AuthenticationService', 'DTMTrackerService'];
  function SamlLogin($location, $rootScope, AuthenticationService, DTMTrackerService) {
    var samlLogin = {}

    samlLogin.login = function(){
      var thisUrl = $location.path();
      var accountID;
      var userData = [];
      // var data = 'data';
      var tempDate = new Date();
      var pathSections = thisUrl.split('/');
      if (pathSections[1] === 'saml'){
       if (pathSections[2] === 'login') {
        accountID = pathSections[3];
        userData = {'data':{'accountID': accountID, 'lastAccessTime': tempDate}};
        AuthenticationService.setAuthentication(userData);
        DTMTrackerService.directCall("signin-complete");
        console.log('this is a number: ' + accountID);
        $location.path('/view-authorizations/');
      } else if (pathSections[2] === 'error'){
       $rootScope.serverError=[];
       var eCode = getParameterByName('code');
       $rootScope.serverError.push({'errorCode': eCode});
      }}
    };
    return samlLogin;
 }
